module.exports = __webpack_public_path__ + "img/397288c8aa8619a369f55fd3a43ef7ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo15.png
// module id = 923
// module chunks = 5